import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  pageNumber: 0,
  totalPages: 0,
  activityData: {
    videoShared: [],
    videoEdits: [],
    memberAdded: [],
    eventAdded: [],
    seasonAdded: [],
    scheduleAdded: [],
    flag: "",
    AllActivity: [],
  },
  loading: false,
  error: "",
};

export const ActivityHistoryReducer = (
  state = initialState,
  { type, payload }
) => {
  const previousState = JSON.parse(JSON.stringify(state));
  switch (type) {
    case ActionTypes.GET_VIDEO_EDIT_ACTIVITY:
      return {
        ...previousState,
        activityData: {
          videoEdits: payload.status
            ? payload.data.activityResponses
            : [
                ...previousState.activityData.videoEdits,
                ...payload.data.activityResponses,
              ],
          videoShared: [],
          memberAdded: [],
          eventAdded: [],
          seasonAdded: [],
          scheduleAdded: [],
          flag: "VIDEO_EDIT",
          AllActivity: [],
        },
        pageNumber: payload.status ? 1 : previousState.pageNumber + 1,
        totalPages: payload.data.totalPages,
        loading: false,
        error: "",
      };

    case ActionTypes.GET_VIDEO_SHARED_ACTIVITY:
      return {
        ...previousState,
        activityData: {
          videoEdits: [],
          videoShared: payload.status
            ? payload.data.activityResponses
            : [
                ...previousState.activityData.videoShared,
                ...payload.data.activityResponses,
              ],
          memberAdded: [],
          seasonAdded: [],
          scheduleAdded: [],
          eventAdded: [],
          flag: "VIDEO_SHARED",
          AllActivity: [],
        },
        pageNumber: payload.status ? 1 : previousState.pageNumber + 1,
        totalPages: payload.data.totalPages,
        loading: false,
        error: "",
      };

    case ActionTypes.GET_MEMBER_ADDED_ACTIVITY:
      return {
        ...previousState,
        activityData: {
          videoEdits: [],
          videoShared: [],
          memberAdded: payload.status
            ? payload.data.activityResponses
            : [
                ...previousState.activityData.memberAdded,
                ...payload.data.activityResponses,
              ],
          seasonAdded: [],
          scheduleAdded: [],
          eventAdded: [],
          flag: "MEMBER_ADDED",
          AllActivity: [],
        },
        pageNumber: payload.status ? 1 : previousState.pageNumber + 1,
        totalPages: payload.data.totalPages,
        loading: false,
        error: "",
      };

    case ActionTypes.GET_SEASON_ADDED_ACTIVITY:
      return {
        ...previousState,
        activityData: {
          videoEdits: [],
          videoShared: [],
          memberAdded: [],
          seasonAdded: payload.status
            ? payload.data.activityResponses
            : [
                ...previousState.activityData.seasonAdded,
                ...payload.data.activityResponses,
              ],
          scheduleAdded: [],
          eventAdded: [],
          flag: "SEASON_ADDED",
          AllActivity: [],
        },
        pageNumber: payload.status ? 1 : previousState.pageNumber + 1,
        totalPages: payload.data.totalPages,
        loading: false,
        error: "",
      };

    case ActionTypes.GET_SCHEDULE_ADDED_ACTIVITY:
      return {
        ...previousState,
        activityData: {
          videoEdits: [],
          videoShared: [],
          memberAdded: [],
          seasonAdded: [],
          scheduleAdded: payload.status
            ? payload.data.activityResponses
            : [
                ...previousState.activityData.scheduleAdded,
                ...payload.data.activityResponses,
              ],
          eventAdded: [],
          flag: "SCHEDULE_ADDED",
          AllActivity: [],
        },
        pageNumber: payload.status ? 1 : previousState.pageNumber + 1,
        totalPages: payload.data.totalPages,
        loading: false,
        error: "",
      };

    case ActionTypes.GET_ALL_ACTIVITY:
      return {
        ...previousState,
        activityData: {
          videoEdits: [],
          videoShared: [],
          memberAdded: [],
          seasonAdded: [],
          scheduleAdded: [],
          eventAdded: [],
          flag: "ALL",
          AllActivity: payload.status
            ? payload?.data?.activityResponses
            : [
                ...previousState.activityData.AllActivity,
                ...payload?.data?.activityResponses,
              ],
        },
        pageNumber: payload.status ? 1 : previousState.pageNumber + 1,
        totalPages: payload?.data?.totalPages,
        loading: false,
        error: "",
      };

    case ActionTypes.ACTIVITY_HISTORY_LOADING:
      return {
        ...previousState,
        loading: payload,
      };

    case ActionTypes.ACTIVITY_HISTORY_ERROR:
      return {
        ...previousState,
        error: payload,
      };

    case ActionTypes.RESET_ACTIVITY_HISTORY_INITIAL_STATE:
      return initialState;

    default:
      return previousState;
  }
};
